import { create } from 'zustand';
import { conditionalDevtools } from '@/lib/storeMiddleware';

interface TodoModalStoreState {
  repeatDialogOpen: boolean;
  tagManagerOpen: boolean;
  linkEmailDialogOpen: boolean;
  openRepeatDialog: () => void;
  closeRepeatDialog: () => void;
  openTagManager: () => void;
  closeTagManager: () => void;
  openLinkEmailDialog: () => void;
  closeLinkEmailDialog: () => void;
}

export const useTodoModalStore = create<TodoModalStoreState>()(
  conditionalDevtools(
    (set) => ({
      repeatDialogOpen: false,
      tagManagerOpen: false,
      linkEmailDialogOpen: false,
      openRepeatDialog: () => set({ repeatDialogOpen: true }),
      closeRepeatDialog: () => set({ repeatDialogOpen: false }),
      openTagManager: () => set({ tagManagerOpen: true }),
      closeTagManager: () => set({ tagManagerOpen: false }),
      openLinkEmailDialog: () => set({ linkEmailDialogOpen: true }),
      closeLinkEmailDialog: () => set({ linkEmailDialogOpen: false }),
    }),
    { name: 'TodoModalStore' }
  )
);
